/**
 * Photo Formatter.
 */
window.photoFormatter = function(value, row) {
    let alt = row.first_name+' '+row.last_name;
    let html = '';
    html += '<img src="'+value+'" class="rounded-circle" alt="'+alt+'" width="50" />';
    return html;
};
